import {
  Box,
  Button,
  HStack,
  Input,
  Modal,
  ScrollView,
  Text,
  VStack,
} from "native-base";
import * as React from "react";
import { useTranslation } from "react-i18next";
import Colors from "../../const/Colors";
import { API } from "../../api/types";
import { useWindowDimensions } from "react-native";

const AiUpdateInfoPopup = ({
  input,
  onCancel,
  onOk,
  onChange,
}: {
  input?: API.AiInfo[];
  onOk: () => void;
  onCancel: () => void;
  onChange: (key: string, value: string) => void;
}) => {
  // ppw("AiUpdateInfoPopup().input", input);
  //=========== HOOK ==========
  const { t } = useTranslation();
  const { width, height } = useWindowDimensions();

  // useEffect(() => {
  //   ppw("AiUpdateInfoPopup().height", height);
  // });

  //=========== OUT ==========
  return (
    <Modal
      isOpen={true}
      background={"rgba(0,0,0,0.5)"}
    >
      <Modal.Content
        width={"90vw"}
        maxWidth={"90vw"}
        maxHeight={"70vh"}
        borderRadius={8}
      >
        <Box
          id={"info"}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          // bg={"red.500"}
        >
          <Text
            id={"title"}
            paddingTop={"16px"}
            fontSize={22}
            // height={"100px"}
          >
            {t("updateInformation")}
          </Text>
          <ScrollView
            // height={"100px"}
            maxHeight={"30vh"}
          >
            <VStack id={"info-input"}>
              {input &&
                input
                  ?.filter((m) => m.isNeedUpdate)
                  ?.map((m, i) => {
                    return (
                      <VStack
                        key={i.toString()}
                        width={"100%"}
                        justifyContent={"space-between"}
                        alignItems={"center"}
                        // bg={"red.500"}
                      >
                        <HStack
                          key={i.toString()}
                          width={"100%"}
                          justifyContent={"space-between"}
                          alignItems={"center"}
                          // bg={"red.500"}
                        >
                          <Text id={"input-k"} width={"100px"} fontSize={16}>
                            {""}
                          </Text>
                          <Input
                            width={"50vw"}
                            // bg={"green.500"}
                            variant="underlined"
                            value={`${m.v}`}
                            borderBottomColor={
                              Colors.healthCheckInputBottomLine
                            }
                            placeholder={`${t(m.k)}`}
                            textAlign={"center"}
                            // fontStyle={"bold"}
                            color={Colors.black}
                            fontSize={16}
                            onChangeText={(value) => {
                              onChange(m.k, value);
                            }}
                            keyboardType="numeric"
                          />
                          <Text id={"input-k"} width={"100px"} fontSize={16}>
                            {t(`${m.u}`)}
                          </Text>
                        </HStack>
                        {m.errorMessage && (
                          <Text
                            id={"error-t"}
                            width={"100%"}
                            fontSize={16}
                            color={Colors.redError}
                            textAlign={"center"}
                            maxWidth={"80vw"}
                          >
                            {`${t(m.errorMessage)}`}
                          </Text>
                        )}
                      </VStack>
                    );
                  })}
            </VStack>
          </ScrollView>
          <HStack
            id={"action"}
            width={"100%"}
            // height={"100px"}
            paddingTop={"8px"}
          >
            <Button
              flex={1}
              bg={Colors.primaryColor}
              _text={{
                color: "black",
                fontSize: 16,
              }}
              borderRightRadius={0}
              borderTopRadius={0}
              onPress={onCancel}
            >
              {t("cancel")}
            </Button>
            <Box width={"1px"} />
            <Button
              flex={1}
              bg={Colors.primaryColor}
              _text={{
                color: "black",
                fontSize: 16,
              }}
              onPress={onOk}
              borderLeftRadius={0}
              borderTopRadius={0}
            >
              {t("update")}
            </Button>
          </HStack>
        </Box>
      </Modal.Content>
    </Modal>
  );
};

export default AiUpdateInfoPopup;
